import {fetchApi} from "shared/actions/fetchApi"
import {actionMap} from '../reducers/index'
import * as types from './types'
import resetError from "shared/errorHandler/actions/resetError"
import handleError from "shared/errorHandler/actions/handleError"

export default (flightId) => dispatch => {
    dispatch({type: types.GET_FLIGHT_INFO_START})
    dispatch(resetError())
    return fetchApi("/api/fs/schedule/" + flightId)
        .then(response => response.json())
        .then(response => {
            dispatch({
                type: types.GET_FLIGHT_INFO_SUCCESS, response: response
            })
        })
        .catch(error => {
            dispatch({
                type: types.GET_FLIGHT_INFO_FAILURE
            })
            dispatch(handleError({message: error.message, title: "Error during loading flight info."}))
        })
}

export const handler_GET_FLIGHT_INFO_START = (reduxState) => {
    return ({
        ...reduxState
    })
}

export const handler_GET_FLIGHT_INFO_SUCCESS = (reduxState, action) => {
    return ({
        ...reduxState,
        data: action.response
    })
}

export const handler_GET_FLIGHT_INFO_FAILURE = (reduxState) => {
    return ({
        ...reduxState,
        data: undefined
    })
}



actionMap[types.GET_FLIGHT_INFO_START] = handler_GET_FLIGHT_INFO_START
actionMap[types.GET_FLIGHT_INFO_SUCCESS] = handler_GET_FLIGHT_INFO_SUCCESS
actionMap[types.GET_FLIGHT_INFO_FAILURE] = handler_GET_FLIGHT_INFO_FAILURE


// WEBPACK FOOTER //
// ./src/screens/briefing/actions/getFlightInfo.js